// Cities Koning Aannemersbedrijf is active in (Zuid-Holland)
// Maassluis is HQ — listed first as primary local SEO target.
//
// `priority: true` marks cities with verified unique local content that are
// included in the sitemap and indexable. Non-priority cities remain accessible
// on the site but are served with noindex,follow and excluded from sitemap.xml
// until we add unique local content or verified projects for each.
const PRIORITY = new Set([
  "maassluis", "vlaardingen", "schiedam", "rotterdam", "delft", "westland", "den-haag",
]);
export const isPriorityCity = (slug) => PRIORITY.has(slug);

export const cities = [
  {
    slug: "maassluis",
    name: "Maassluis",
    primary: true,
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Vanuit Maassluis verzorgen wij premium renovaties en verbouwingen voor woningen in de Waterweg-regio en heel Zuid-Holland.",
    neighborhoods: ["Centrum", "Sluispolder", "Het Balkon", "Steendijkpolder", "Maassluis-West", "Dijkpolder"],    localContext:
      "Maassluis kent een unieke mix van karakteristieke jaren '30 en '50 woningen rondom het centrum, naoorlogse rijtjeswoningen in Sluispolder en strakke nieuwbouw aan Het Balkon. Wij begrijpen de typische bouwwijze van iedere wijk en houden bij renovaties rekening met fundering, vocht en isolatie-uitdagingen die hier voorkomen.",
  },
  {
    slug: "vlaardingen",
    name: "Vlaardingen",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Renovatiebedrijf voor Vlaardingen — van de historische binnenstad tot Holy en Babberspolder.",
    neighborhoods: ["Centrum", "Holy", "Babberspolder", "Westwijk", "Ambacht", "VOP"],    localContext:
      "In Vlaardingen werken wij regelmatig aan badkamers in bestaande woningen, appartementen en gezinswoningen. Veel klanten willen hun oude badkamer vervangen door een moderne, strak afgewerkte ruimte met inloopdouche, nis, maatwerkverlichting en een onderhoudsvriendelijke afwerking. Ook totaalrenovaties van jaren '30 tot '70 woningen voeren wij hier veel uit.",
  },
  {
    slug: "schiedam",
    name: "Schiedam",
    image: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Aannemer in Schiedam — voor binnenstad-woningen, jaren '30 bouw en moderne appartementen.",
    neighborhoods: ["Binnenstad", "Nieuwland", "Groenoord", "Kethel", "Spaland", "West"],    localContext:
      "Schiedam heeft een rijke mix van monumentale binnenstad-panden, jaren '30 woningen in Oost en West, en modernere wijken als Spaland. Bij renovaties houden wij rekening met de typische krappe ruimte, oude vloerbalken en gemeentelijke regelgeving rondom karakteristieke gevels.",
  },
  {
    slug: "rotterdam",
    name: "Rotterdam",
    image: "https://images.unsplash.com/photo-1512470876302-972faa2aa9a4?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Van Hillegersberg tot Kralingen, van Charlois tot Hoek van Holland — wij zijn de aannemer voor Rotterdam.",
    neighborhoods: ["Kralingen", "Hillegersberg", "Centrum", "Charlois", "Prins Alexander", "Delfshaven"],    localContext:
      "Rotterdam is divers in bouwjaren en architectuur — van prachtige vooroorlogse panden in Kralingen tot strakke nieuwbouw aan de Kop van Zuid. Wij hebben ervaring met VvE-trajecten in appartementencomplexen én met complete villa-renovaties in Hillegersberg en Het Lage Land.",
  },
  {
    slug: "delft",
    name: "Delft",
    image: "https://images.unsplash.com/photo-1558551649-e44c8f992010?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Renovatie- en verbouwspecialist voor zowel de Delftse binnenstad als nieuwbouw in Tanthof en Voorhof.",
    neighborhoods: ["Binnenstad", "Tanthof", "Voorhof", "Buitenhof", "Vrijenban", "TU-wijk"],    localContext:
      "Delft heeft strenge welstandsregels voor de monumentale binnenstad. Wij begeleiden vergunningstrajecten en realiseren renovaties die voldoen aan zowel uw wensen als de gemeentelijke eisen — van inpandige opwaardering tot dakkapellen die volledig in stijl blijven.",
  },
  {
    slug: "westland",
    name: "Westland",
    image: "https://images.unsplash.com/photo-1459679749680-18eb1eb37418?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Aannemer voor Naaldwijk, 's-Gravenzande, Honselersdijk, Wateringen en heel het Westland.",
    neighborhoods: ["Naaldwijk", "'s-Gravenzande", "Honselersdijk", "Wateringen", "De Lier", "Monster", "Kwintsheul"],    localContext:
      "Het Westland kent veel ruime vrijstaande woningen, vaak met een agrarische historie. Wij realiseren hier veelvuldig aan- en uitbouwen, complete renovaties en luxe keukens. Ook duurzaamheidsingrepen als spouwmuur- en dakisolatie zijn populair vanwege de hoge stookkosten van oudere woningen.",
  },
  {
    slug: "den-haag",
    name: "Den Haag",
    image: "https://images.unsplash.com/photo-1577086664693-894d8405334a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Van Scheveningen tot Loosduinen — premium aannemer voor renovaties en verbouwingen in Den Haag.",
    neighborhoods: ["Centrum", "Scheveningen", "Loosduinen", "Benoordenhout", "Statenkwartier", "Bezuidenhout"],    localContext:
      "Den Haag is divers: van monumentale herenhuizen in het Statenkwartier en Benoordenhout tot moderne hoogbouw in het centrum. Wij realiseren hier vooral high-end renovaties met respect voor karakteristieke details, en strakke moderne badkamers in appartementen.",
  },
  {
    slug: "rijswijk",
    name: "Rijswijk",
    image: "https://images.unsplash.com/photo-1577086664693-894d8405334a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Renovatie en verbouwing in Rijswijk — van karakteristieke jaren '30 tot moderne nieuwbouw in RijswijkBuiten.",
    neighborhoods: ["Centrum", "Oud-Rijswijk", "Te Werve", "RijswijkBuiten", "Steenvoorde", "Hoekpolder"],    localContext:
      "Rijswijk groeit hard met RijswijkBuiten, maar heeft ook veel vooroorlogse woningen die om opwaardering vragen. Onze klanten kiezen vaak voor complete badkamerrenovaties, keukenupgrades en aanbouw om woningen toekomstbestendig te maken.",
  },
  {
    slug: "zoetermeer",
    name: "Zoetermeer",
    image: "https://images.unsplash.com/photo-1494145904049-0dca59b4bbad?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Specialist in jaren '80 en '90 woningen — modernisering, uitbouw en compleet renoveren.",
    neighborhoods: ["Rokkeveen", "Buytenwegh", "Seghwaert", "Meerzicht", "Oosterheem", "Driemanspolder"],    localContext:
      "Zoetermeer is een typische groeistad met veel woningen uit de jaren '80 en '90. Deze vragen na 30+ jaar om modernisering: nieuwe keukens, badkamers en betere isolatie. Wij ondersteunen die transitie van A tot Z.",
  },
  {
    slug: "spijkenisse",
    name: "Spijkenisse",
    image: "https://images.unsplash.com/photo-1576924542622-772281b13aa8?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Aannemer voor Spijkenisse en omgeving — Akkers, Maaswijk, De Hoek en Vriesland.",
    neighborhoods: ["Centrum", "De Akkers", "Maaswijk", "De Hoek", "Vriesland", "Sterrenkwartier"],    localContext:
      "In Spijkenisse werken wij veel aan rijtjeswoningen en hoekwoningen uit de jaren '70 en '80. Veel klanten kiezen voor uitbouw aan de achterzijde, complete keukenrenovaties en moderne badkamers met inloopdouche.",
  },
  {
    slug: "capelle-aan-den-ijssel",
    name: "Capelle aan den IJssel",
    image: "https://images.unsplash.com/photo-1494145904049-0dca59b4bbad?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Renovaties en verbouwingen in Capelle aan den IJssel, Schollevaar en Schenkel.",
    neighborhoods: ["Centrum", "Schenkel", "Schollevaar", "Middelwatering", "Oostgaarde", "'s-Gravenland"],    localContext:
      "Capelle kent veel jaren '70 en '80 wijken zoals Schollevaar. Onze focus hier ligt op moderniseringen: open keukens via doorbraak, nieuwe badkamers en complete totaalrenovaties van benedenwoningen.",
  },
  {
    slug: "berkel-en-rodenrijs",
    name: "Berkel en Rodenrijs",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Aannemer voor Berkel en Rodenrijs, Bergschenhoek en Bleiswijk — Lansingerland.",
    neighborhoods: ["Centrum", "Westpolder", "Meerpolder", "Bergschenhoek", "Bleiswijk", "Rodenrijs"],    localContext:
      "Lansingerland is een groeigemeente met veel jonge gezinnen in ruime nieuwbouwwoningen. Wij realiseren hier veel hoogwaardige keukens, uitbouwen met grote schuifpuien en luxe master-badkamers.",
  },
  {
    slug: "hoek-van-holland",
    name: "Hoek van Holland",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Renovaties aan de kust — Hoek van Holland en omliggende dorpen.",
    neighborhoods: ["Centrum", "Strandweg", "Duinweg", "Berghaven"],    localContext:
      "Aan de kust spelen vocht, wind en zoute lucht een grotere rol. Wij gebruiken hier materialen die bestand zijn tegen het zilte klimaat — denk aan corrosie-vrij hang- en sluitwerk en hoogwaardige beglazing.",
  },
  {
    slug: "dordrecht",
    name: "Dordrecht",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Renovaties in Dordrecht — van klassieke jaren '30 woningen tot strakke moderne afwerking.",
    neighborhoods: ["Centrum", "Dubbeldam", "Krispijn", "Stadspolders", "Sterrenburg"],    localContext:
      "Dordrecht heeft een prachtige monumentale binnenstad en kenmerkende jaren '30 wijken. Wij hebben ervaring met de specifieke uitdagingen van oudere panden: enkelsteens muren, hoge plafonds en houten vloeren.",
  },
  {
    slug: "leiden",
    name: "Leiden",
    image: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    intro: "Werkzaam in Leiden Centrum, Stevenshof en Roomburg — historische woningen met respect voor karakter.",
    neighborhoods: ["Binnenstad", "Stevenshof", "Roomburg", "Merenwijk", "Morsdistrict"],    localContext:
      "Leiden is een echte studentenstad met een fantastische historische binnenstad. Renovaties hier vragen om vakmanschap én vergunningenkennis. Wij realiseren strakke moderne afwerking achter karakteristieke gevels.",
  },
];

export const findCity = (slug) => cities.find((c) => c.slug === slug);
